<template>
  <div class="image-widget">
    <a :href="options.link || options.url" target="_blank"><img :src="options.url"></a>
  </div>
</template>

<script>

export default {
  name: 'ImageWidget',
  props: ["options"],
}
</script>

<style scoped>
  img {
    width: 100%;
  }
</style>
